"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomError = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ExecuteProtectedError_1 = require("./ExecuteProtectedError");
var DataTooLargeError_1 = require("./DataTooLargeError");
var NoDataError_1 = require("./NoDataError");
var OtherError_1 = require("./OtherError");
var sizingUtils_1 = require("./sizingUtils");
exports.CustomError = function (_a) {
    var error = _a.error, height = _a.height, width = _a.width, isCustomWidgetHeightEnabled = _a.isCustomWidgetHeightEnabled, forceFullContent = _a.forceFullContent;
    var fullContent = forceFullContent || (isCustomWidgetHeightEnabled ? sizingUtils_1.shouldRenderFullContent(height, width) : true);
    if (sdk_ui_1.isProtectedReport(error)) {
        return react_1.default.createElement(ExecuteProtectedError_1.ExecuteProtectedError, { fullContent: fullContent });
    }
    else if (sdk_ui_1.isDataTooLargeToDisplay(error) || sdk_ui_1.isDataTooLargeToCompute(error)) {
        return react_1.default.createElement(DataTooLargeError_1.DataTooLargeError, { fullContent: fullContent });
    }
    else if (sdk_ui_1.isNoDataSdkError(error)) {
        return react_1.default.createElement(NoDataError_1.NoDataError, { fullContent: fullContent });
    }
    else if (error) {
        return react_1.default.createElement(OtherError_1.OtherError, { fullContent: fullContent });
    }
    return null;
};
//# sourceMappingURL=CustomError.js.map